export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  showDemoLogins: import.meta.env.VITE_SHOW_DEMO_LOGINS === 'true',
} as const;
